// extracted by mini-css-extract-plugin
export default {"root":"RadioControl_root__Zlp7U","label":"RadioControl_label__siM-b","option":"RadioControl_option__a+15u"};